import { useRef, useState } from "react"

import Style from "./style"
import show from "./asset/show.svg"
import hide from "./asset/hide.svg"

import DefaultInput from "shared/ui/DefaultInput"
import DefaultButton from "shared/ui/DefaultButton"
import useTmpAuthAtom from "shared/model/useConfrimCookie"

import ContactInput from "widget/ContactInput"

import usePutAccountPassword from "entity/auth/usePutAuthPassword"

const FindPw = () => {
    const idRef = useRef()
    const newPwRef = useRef()
    const countryCodeRef = useRef()
    const contactRef = useRef()

    const [isPasswordShow, setIsPasswordShow] = useState(false)

    const [putAccountPwEvent] = usePutAccountPassword(idRef, newPwRef)
    const [tmpToken] = useTmpAuthAtom()

    return (
        <Style.Wrapper>
            <Style.Title>FORGOT PASSWORD</Style.Title>

            <Style.Form>
                <DefaultInput title="아이디" inputRef={idRef} required placeholder="아이디" hint="1~20자" />
                <ContactInput countryCodeRef={countryCodeRef} contactRef={contactRef} />

                {tmpToken &&
                    <DefaultInput title="새로운 비밀번호" inputRef={newPwRef} type={!isPasswordShow && "password"} required placeholder="비밀번호" hint={`6자 이상, 20자 이하로 입력해주세요.\n영문, 숫자, 특수문자를 모두 포함시켜 주세요.`}>
                        <Style.ShowButton onClick={() => setIsPasswordShow(state => !state)}>
                            <img src={isPasswordShow ? hide : show} />
                        </Style.ShowButton>
                    </DefaultInput>
                }
            </Style.Form>

            <Style.ButtonDiv>
                <DefaultButton clickEvent={putAccountPwEvent}>비밀번호 변경하기</DefaultButton>
            </Style.ButtonDiv>

        </Style.Wrapper>
    )
}

export default FindPw